import { IconProps } from './index';

const EyeOffLine: React.VFC<IconProps> = ({
    title,
    titleId,
    width = 12,
    height = 13,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M8.94108 10.3041C8.06168 10.8618 7.04144 11.1572 6.00008 11.1556C3.30408 11.1556 1.06108 9.21555 0.590576 6.65555C0.805591 5.49091 1.39139 4.427 2.26058 3.62255L0.696076 2.05955L1.40358 1.35205L11.3031 11.2521L10.5956 11.9591L8.94058 10.3041H8.94108ZM2.96758 4.33055C2.28808 4.94835 1.81473 5.75994 1.61158 6.65555C1.76772 7.33878 2.08121 7.97612 2.52708 8.51685C2.97295 9.05757 3.53889 9.48675 4.17985 9.7702C4.82082 10.0537 5.5191 10.1836 6.21912 10.1496C6.91914 10.1156 7.60157 9.91873 8.21208 9.57455L7.19808 8.56055C6.76642 8.83246 6.25518 8.9496 5.7482 8.89277C5.24121 8.83594 4.7686 8.6085 4.40786 8.24777C4.04713 7.88703 3.81969 7.41441 3.76286 6.90743C3.70602 6.40045 3.82317 5.88921 4.09508 5.45755L2.96758 4.33055ZM6.45708 7.81955L4.83608 6.19855C4.74711 6.42502 4.72617 6.67253 4.77583 6.91072C4.82549 7.14892 4.94358 7.36744 5.11564 7.53949C5.28769 7.71154 5.50621 7.82964 5.7444 7.8793C5.9826 7.92896 6.23011 7.90802 6.45658 7.81905L6.45708 7.81955ZM10.4036 8.95155L9.68808 8.23655C10.0223 7.7602 10.2603 7.22314 10.3886 6.65555C10.2527 6.06041 9.99721 5.49912 9.63765 5.0058C9.27809 4.51247 8.82197 4.09741 8.29701 3.78585C7.77205 3.47429 7.18922 3.27273 6.58394 3.19343C5.97866 3.11413 5.36358 3.15874 4.77608 3.32455L3.98708 2.53555C4.61058 2.29055 5.29008 2.15555 6.00008 2.15555C8.69608 2.15555 10.9391 4.09555 11.4096 6.65555C11.2564 7.4884 10.912 8.27434 10.4036 8.95155V8.95155ZM5.86158 4.40955C6.17983 4.38988 6.49863 4.43808 6.79685 4.55096C7.09506 4.66383 7.36588 4.83881 7.59135 5.06428C7.81682 5.28975 7.99179 5.56056 8.10467 5.85878C8.21754 6.15699 8.26574 6.4758 8.24608 6.79405L5.86108 4.40955H5.86158Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default EyeOffLine;
